/** Tenant IDs from auth profile — UX/API hints only; backend enforces scope. */

function firstPositiveId(...candidates: unknown[]): number | undefined {
  for (const candidate of candidates) {
    const n = Number(candidate)
    if (Number.isFinite(n) && n > 0) return n
  }
  return undefined
}

function isCrewRole(currentUser: Record<string, unknown>): boolean {
  const role = currentUser.role as {roleType?: unknown; roleName?: unknown} | undefined
  const roleToken = String(role?.roleType ?? role?.roleName ?? currentUser.roleType ?? '').toUpperCase()
  return roleToken === 'CREW'
}

export function procurementTenantCgaId(currentUser: unknown): number | undefined {
  const u = currentUser as Record<string, unknown> | null | undefined
  if (!u) return undefined
  const companyGroupAdmin = u.companyGroupAdmin as {id?: unknown} | undefined
  const cgaid = u.cgaid as {id?: unknown} | undefined
  const company = u.company as {cgaid?: {id?: unknown}} | undefined
  const companyAdmin = u.companyAdmin as {cgaid?: {id?: unknown}} | undefined
  const vessel = u.vessel as {
    companyGroupAdminId?: unknown
    companyGroupAdmin?: {id?: unknown}
    companyAdmin?: {cgaid?: {id?: unknown}}
  } | undefined
  const crew = u.crew as {companyGroupAdminId?: unknown; companyGroupAdmin?: {id?: unknown}} | undefined

  // Crew roleEntityId is the crew record id — never use it as CGA.
  if (isCrewRole(u)) {
    return firstPositiveId(
      vessel?.companyGroupAdminId,
      vessel?.companyGroupAdmin?.id,
      vessel?.companyAdmin?.cgaid?.id,
      crew?.companyGroupAdminId,
      crew?.companyGroupAdmin?.id,
      u.companyGroupAdminId,
      companyGroupAdmin?.id,
    )
  }

  return firstPositiveId(
    u.companyGroupAdminId,
    companyGroupAdmin?.id,
    cgaid?.id,
    u.cgaid,
    company?.cgaid?.id,
    companyAdmin?.cgaid?.id,
    vessel?.companyGroupAdminId,
    vessel?.companyGroupAdmin?.id,
  )
}

export function procurementTenantVesselId(currentUser: unknown): number | undefined {
  const u = currentUser as Record<string, unknown> | null | undefined
  if (!u) return undefined
  const vessel = u.vessel as { id?: unknown } | undefined
  const n = Number(vessel?.id ?? u.vesselId ?? 0)
  return Number.isFinite(n) && n > 0 ? n : undefined
}
